/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { Icon } from '@salesforce/design-system-react';
import PropTypes from 'prop-types';
import React from 'react';

import { ProvisionedCard } from '../../homepage-card';
import CardFooter from '../../card-footer';
import RecentlyEditedJourney from './item';
import UnprovisionedJourneyBuilder from '../unprovisioned/unprovisioned-journey-builder';

import { JOURNEY_STATUS_DB_VALUE_MAP } from '../../../constants';

const journeyBuilderIcon = (
  <Icon category="custom" name="custom106" size="small" style={{ backgroundColor: '#b17fd1' }} />
);

function handleDeepLink(onDeepLink, journey) {
  if (onDeepLink) {
    let link;

    if (journey && journey.id && journey.version) {
      link = `/#${journey.id}/${journey.version}`;
    }

    onDeepLink({
      appName: 'Journey Builder',
      analyticsName: 'Recently Edited Journeys',
      link,
    });
  }
}

function localizeStatus(localizations, status) {
  return status
    ? localizations[`homepage.cards.status.journey.${JOURNEY_STATUS_DB_VALUE_MAP[status.toLowerCase()]}`]
    : '';
}

function RecentlyEditedJourneysCard({ className, editedJourneys, localizations, onDeepLink, unprovisioned }) {
  return (
    <div>
      {unprovisioned ? (
        <UnprovisionedJourneyBuilder
          className={className}
          heading={localizations['homepage.cards.recently_edited_journeys.heading']}
          icon={journeyBuilderIcon}
          localizations={localizations}
        />
      ) : (
        <ProvisionedCard
          className={className}
          heading={localizations['homepage.cards.recently_edited_journeys.heading']}
          icon={journeyBuilderIcon}
          forceShowFooter
          footer={<CardFooter onClick={() => handleDeepLink(onDeepLink)} />}
        >
          {editedJourneys && editedJourneys.length > 0 ? (
            <ul className="slds-has-dividers--bottom-space">
              {editedJourneys.map((email) => (
                <RecentlyEditedJourney
                  {...email}
                  status={localizeStatus(localizations, email.status)}
                  key={email.id}
                  localizations={localizations}
                  onClick={() => handleDeepLink(onDeepLink, email)}
                />
              ))}
            </ul>
          ) : (
            <div className="slds-text-align--center slds-text-heading--medium" style={{ marginTop: '104px' }}>
              {localizations['homepage.cards.recently_edited_journeys.no_recent']}
            </div>
          )}
        </ProvisionedCard>
      )}
    </div>
  );
}

RecentlyEditedJourneysCard.displayName = 'Recently Edited Journeys Card';

RecentlyEditedJourneysCard.propTypes = {
  className: PropTypes.string,
  editedJourneys: PropTypes.array,
  localizations: PropTypes.object,
  onDeepLink: PropTypes.func,
  unprovisioned: PropTypes.bool,
};

export default RecentlyEditedJourneysCard;
